// extracted by mini-css-extract-plugin
export default {"AccountRecoveryContainer":"AccountRecovery_AccountRecoveryContainer__cU0pg","loginDetali":"AccountRecovery_loginDetali__T2IPe","loginNotion":"AccountRecovery_loginNotion__p7Eb5"};